module.exports = __webpack_public_path__ + "img/58.6ecf0549.png";